import React, { useState, useEffect, useContext} from 'react';
import 'dayjs/locale/pt-br';
import dayjs, {Dayjs} from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import MUIDataTable from 'mui-datatables';
import { Link as RouterLink } from 'react-router-dom';
import { mask } from "remask";

import {
  TableCell,
  TableFooter,
  TableRow,
  makeStyles
} from "@material-ui/core";

// material
import {
    Card,
    Stack,
    Alert,
    Button,
    Container,
    Typography,
    MenuItem,  
    ListItemIcon, 
    ListItemText,
    AlertTitle,
    TextField,
    Avatar,
    Autocomplete
  } from '@mui/material';

import { ThemeProvider } from '@mui/material/styles';  
// components
import Loading from '../../components/Loading';
import Theme from '../../components/Button';

import {api, reiniciarToken, consultaVendas, excluirVendas, atualizarSituacaoVenda, consUsuariosEmpresa } from '../../services/api';
// context
import { AuthContext } from '../../contexts/auth';  

import Page from '../../components/Page';
import Iconify from '../../components/Iconify';

// utils
import { fDateFormatCalendario, fDatePadrao, fDiferencaEntreDatas } from '../../utils/formatTime';
import { fFormataDinheiro } from '../../utils/formatNumber';
import produtoPadrao from '../../images/produto_padrao.jpg';
import imagemServico from '../../images/imagem_servico.png';

export default function ConsultaVenda() {
  
  const { logout } = useContext(AuthContext);
  const [dados, setData] = useState([]);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [dataInicio, setDataInicio] = useState( dayjs() );
  const [dataFim, setDataFim] = useState( dayjs() );
  const [formaPagamento, setFormaPagamento] = useState('');
  const [statusViagem, setStatusViagem] = useState('');
  const [showElement, setShowElement] = useState(false);
  const [exibeStatusViagem, setExibeStatusViagem] = useState(false);
  const [usuarios, setListUsuario] = useState([]);
  const [usuarioParam, setUsuario] = useState('');

  let columns;
  let sumValorVenda; 
  let sumValorDespesa;
  let sumLucroLiquido;

  const getListas = async () => {
    
    const responseProduto = await consUsuariosEmpresa();

    if(responseProduto.erro === true) {
      if (responseProduto.mensagem === 'O Token é inválido!' || responseProduto.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      responseProduto.data.forEach((valores) => {
        setListUsuario(usuarios => [...usuarios, {usuario: valores.usuario, descricao: valores.usuario}])
      });
    };
  }

  const getVendas = async () => {
    setData([]);

    const retorno = await reiniciarToken();
    setRemoveLoading(false);
    
    if (localStorage.getItem(['menu_restrito']) !== '1'){
      setShowElement(true);  
    }  

    if (localStorage.getItem(['tipo_comercio']) === '5'){
      setExibeStatusViagem(true);  
    }
    
    if(retorno.erro === true) {
      if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
        logout();
      }
    }else{
      localStorage.setItem("token", retorno.data.token);
      api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
    }

    const response = await consultaVendas(fDateFormatCalendario(dataInicio), fDateFormatCalendario(dataFim), formaPagamento, usuarioParam, statusViagem);
    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      setRemoveLoading(true);
      response.data.forEach((valores) => {
        let descricaoVenda
        let dataPagamento
        let formaPagamento
        let date1 
        let date2 
        let diffDays
        
        if (valores.produto != null) {
            descricaoVenda = valores.produto.descricao;
        }else if (localStorage.getItem(['tipo_comercio']) === '2') {
           if (valores.pedido_mesa > 0) {
              descricaoVenda = "Venda Mesa"; 
           }else {
              descricaoVenda = "Venda Balcão"; 
           }                     
        }else{
            descricaoVenda = "Venda Balcão";
        };

        if (valores.forma_pagamento === 1) {
          formaPagamento = "Dinheiro"
        }else if (valores.forma_pagamento === 2) {
          formaPagamento = "PIX"
        }else if (valores.forma_pagamento === 3) {
          formaPagamento = "Cartão de Crédito"
        }else if (valores.forma_pagamento === 4) {  
          formaPagamento = "Cartão de Débito"  
        }  

        dataPagamento = valores.data_pagamento != null ? valores.data_pagamento.concat('T00:00:00-0300') : null;
        
        if (dataPagamento != null){
          date1 = new Date(valores.data_venda);
          date2 = new Date(dataPagamento);
          
          dataPagamento = fDatePadrao(dataPagamento);
          diffDays = fDiferencaEntreDatas(date2, date1);
        }

        setData(dados => [...dados, {id_venda: valores.id_venda, 
                                     data_venda: fDatePadrao(valores.data_venda),
                                     data_pagamento: dataPagamento,
                                     forma_pagamento: formaPagamento,
                                     dias_pagamento: diffDays, 
                                     nome: valores.nome, 
                                     descricao: descricaoVenda,
                                     qtde_venda: valores.qtde_venda,
                                     valor_venda: valores.valor_venda,
                                     total_pagamento: valores.total_pagamento,
                                     lucro_liquido: valores.lucro_liquido,
                                     total_pagamento_formatado: fFormataDinheiro(valores.total_pagamento),
                                     lucro_liquido_formatado: fFormataDinheiro(valores.lucro_liquido),
                                     valor_venda_formatado: fFormataDinheiro(valores.valor_venda),
                                     usuario: valores.usuario,
                                     situacao: valores.situacao,
                                     numero_pedido_empresa: valores.numero_pedido_empresa ? mask(valores.numero_pedido_empresa, ['99999']) : null,
                                     url: valores.url,
                                     companhia_aerea: valores.companhia_aerea,
                                     origem: valores.origem, 
                                     destino: valores.destino, 
                                     data_ida: fDatePadrao(valores.data_ida),
                                     data_volta: valores.data_volta ? fDatePadrao(valores.data_volta) : null, 
                                     codigo_reserva: valores.codigo_reserva}]);  
      });
      
    }; 
  }

  useEffect(() => {
    setData([]);
    getListas();
    getVendas();
  },[])  

  const [status, setStatus] = useState({
    type: '',
    mensagem: ''
  }) 
  
  
  const excluirVenda = async (id) => {
    const response = await excluirVendas(id);
    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }else {
        setStatus({
          type: "erro",
          mensagem: response.mensagem
        })
      }
    }else {
      setStatus({
        type: "success",
        mensagem: response.data.mensagem
      })
      setData([]);
      getVendas();
    }; 
  } 

  const atualizaSituacao = async (id, situacao) => {
    const response = await atualizarSituacaoVenda(id, {"situacao": situacao});
    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }else {
        setStatus({
          type: "erro",
          mensagem: response.mensagem
        })
      }
    }else {
      setStatus({
        type: "success",
        mensagem: response.data.mensagem
      })
      setData([]);
      getVendas();
    }; 
  } 

  let descricaoBotao;
  let linkUsado;
  if (localStorage.getItem(['tipo_comercio']) === '2') {
    descricaoBotao = "Produtos";
    linkUsado = '/venda_avulsa_geral/itens/';
  }else if ((localStorage.getItem(['tipo_comercio']) === '3') || (localStorage.getItem(['tipo_comercio']) === '6')) {
    descricaoBotao = "Produtos";
    linkUsado = '/venda_avulsa_geral/itens/';
  }else{
    descricaoBotao = "Despesas";
    linkUsado = '/despesa/despesas_venda/';
  };  

  if (localStorage.getItem(['tipo_comercio']) === '1') {
    // Empresa de Serviços
    if (localStorage.getItem(['menu_restrito']) === '1') {
      columns = [{name: "",
                  options: {
                    filter: false,
                    sort: false,
                    empty: true,
                    customBodyRenderLite: (dataIndex, rowIndex) =>  {
                      return (
                        <> 
                          <Avatar src={dados[dataIndex].url ? dados[dataIndex].url : imagemServico} alt="imagemProduto" sx={{ width: 100, height: 100 }} />
                        </> 
                      );
                  }
                  }
               }
              ,{name:"id_venda", label: "Código"} 
              ,{name:"data_venda", label: "Data Venda"}
              ,{name:"forma_pagamento", label: "Forma Pagto"} 
              ,{name:"nome", label: "Cliente"}
              ,{name:"descricao", label: "Produto/Serviço"}
              ,{name:"qtde_venda", label: "Qtde Venda"}
              ,{name:"valor_venda_formatado", label: "Valor Venda"}
              ,{name:"usuario", label: "Responsável"}
              ];
    }else{
      columns = [{name: "Ação",
                options: {
                  filter: false,
                  sort: false,
                  empty: true,
                  customBodyRenderLite: (dataIndex, rowIndex) =>  {
                    return (
                      <> 
                        <MenuItem onClick={() => excluirVenda(dados[dataIndex].id_venda)} sx={{ color: 'text.secondary' }}>
                          <ListItemIcon>
                              <Iconify icon="eva:trash-2-outline" width={24} height={24} />
                          </ListItemIcon>
                        </MenuItem>

                        <MenuItem component={RouterLink} to={`/venda/editar/${dados[dataIndex].id_venda}`} sx={{ color: 'text.secondary' }}>
                          <ListItemIcon>
                              <Iconify icon="eva:edit-fill" width={24} height={24} />
                          </ListItemIcon>
                        </MenuItem>
                      </> 
                    );
                  }
                }
              }
              ,{name: "",
                options: {
                  filter: false,
                  sort: false,
                  empty: true,
                  customBodyRenderLite: (dataIndex, rowIndex) =>  {
                    return (
                      <> 
                        <Avatar src={dados[dataIndex].url ? dados[dataIndex].url : imagemServico} alt="imagemProduto" sx={{ width: 100, height: 100 }} />
                      </> 
                    );
                }
                }
              }
              ,{name:"id_venda", label: "Código"} 
              ,{name:"data_venda", label: "Data Venda"}
              ,{name:"forma_pagamento", label: "Forma Pagto"} 
              ,{name:"nome", label: "Cliente"}
              ,{name:"descricao", label: "Produto/Serviço"}
              ,{name:"qtde_venda", label: "Qtde Venda"}
              ,{name:"valor_venda_formatado", label: "Valor Venda"}
              ,{name:"usuario", label: "Responsável"}
              ];
    }
  }else if (localStorage.getItem(['tipo_comercio']) === '2') {
      // Restaurante/Lanchonete
      if (localStorage.getItem(['menu_restrito']) === '1') {
          columns = [{name:"id_venda", label: "Código"} 
                    ,{name:"data_venda", label: "Data Venda"} 
                    ,{name:"forma_pagamento", label: "Forma Pagto"}
                    ,{name:"nome", label: "Cliente"}
                    ,{name:"descricao", label: "Produto/Serviço"}
                    ,{name:"qtde_venda", label: "Qtde Venda"}
                    ,{name:"valor_venda_formatado", label: "Valor Venda"}
                    ,{name:"usuario", label: "Responsável"}
                    ,{name: "",
                      options: {
                        filter: false,
                        sort: false,
                        empty: true,
                        customBodyRenderLite: (dataIndex, rowIndex) =>  {
                          return (
                            <> 
                              <ThemeProvider theme={Theme}>
                                <Button variant="contained" color="neutral" component={RouterLink} to={`${linkUsado}${dados[dataIndex].id_venda}`}>
                                  {descricaoBotao}
                                </Button>
                              </ThemeProvider>
                            </> 
                          );
                        }
                      }
                    }
                    ];                
      }else{  
          columns = [{name: "Ação",
                      options: {
                        filter: false,
                        sort: false,
                        empty: true,
                        customBodyRenderLite: (dataIndex, rowIndex) =>  {
                          return (
                            <> 
                              <MenuItem onClick={() => excluirVenda(dados[dataIndex].id_venda)} sx={{ color: 'text.secondary' }}>
                                <ListItemIcon>
                                    <Iconify icon="eva:trash-2-outline" width={24} height={24} />
                                </ListItemIcon>
                              </MenuItem>
                            </> 
                          );
                        }
                      }
                    }
                    ,{name:"id_venda", label: "Código"} 
                    ,{name:"data_venda", label: "Data Venda"} 
                    ,{name:"forma_pagamento", label: "Forma Pagto"}
                    ,{name:"nome", label: "Cliente"}
                    ,{name:"descricao", label: "Produto/Serviço"}
                    ,{name:"qtde_venda", label: "Qtde Venda"}
                    ,{name:"valor_venda_formatado", label: "Valor Venda"}
                    ,{name:"usuario", label: "Responsável"}
                    ,{name: "",
                      options: {
                        filter: false,
                        sort: false,
                        empty: true,
                        customBodyRenderLite: (dataIndex, rowIndex) =>  {
                          return (
                            <> 
                              <ThemeProvider theme={Theme}>
                                <Button variant="contained" color="neutral" component={RouterLink} to={`${linkUsado}${dados[dataIndex].id_venda}`}>
                                  {descricaoBotao}
                                </Button>
                              </ThemeProvider>
                            </> 
                          );
                        }
                      }
                    }
                    ];
      }          
  }else if (localStorage.getItem(['tipo_comercio']) === '3') {  
    // Loja em Geral
    if (localStorage.getItem(['menu_restrito']) === '1') {
      columns = [{name:"id_venda", label: "Código"} 
                ,{name:"forma_pagamento", label: "Forma Pagto"}
                ,{name:"data_venda", label: "Data Venda"}
                ,{name: "situacao", label: "Situação",
                  options: {
                    empty: true,
                    customBodyRenderLite: (dataIndex, rowIndex) =>  {
                      return (
                        <> 
                          <TextField 
                            select
                            size="small"
                            style= {{width: 170}} 
                            value={dados[dataIndex].situacao}
                            onChange={(ev) => {
                              atualizaSituacao(dados[dataIndex].id_venda, ev.target.value)
                            }}
                          >
                            <MenuItem value ={1}>Emitido</MenuItem>
                            <MenuItem value ={2}>Em Separação</MenuItem> 
                            <MenuItem value ={3}>Em Trânsito</MenuItem>
                            <MenuItem value ={4}>Entregue</MenuItem>
                          </TextField>
                        </> 
                      );
                    }
                  }
                } 
                ,{name:"nome", label: "Cliente"}
                ,{name:"qtde_venda", label: "Qtde Venda"}
                ,{name:"valor_venda_formatado", label: "Valor Venda"}
                ,{name:"usuario", label: "Responsável"}
                ,{name: "",
                  options: {
                    filter: false,
                    sort: false,
                    empty: true,
                    customBodyRenderLite: (dataIndex, rowIndex) =>  {
                      return (
                        <> 
                          <ThemeProvider theme={Theme}>
                            <Button variant="contained" color="neutral" component={RouterLink} to={`${linkUsado}${dados[dataIndex].id_venda}`}>
                              {descricaoBotao}
                            </Button>
                          </ThemeProvider>
                        </> 
                      );
                    }
                  }
                }
                ];
    }else{
        columns = [{name: "Ação",
                    options: {
                      filter: false,
                      sort: false,
                      empty: true,
                      customBodyRenderLite: (dataIndex, rowIndex) =>  {
                        return (
                          <> 
                            <MenuItem onClick={() => excluirVenda(dados[dataIndex].id_venda)} sx={{ color: 'text.secondary' }}>
                              <ListItemIcon>
                                  <Iconify icon="eva:trash-2-outline" width={24} height={24} />
                              </ListItemIcon>
                            </MenuItem>
                          </> 
                        );
                      }
                    }
                  }  
                  ,{name:"id_venda", label: "Código"} 
                  ,{name:"forma_pagamento", label: "Forma Pagto"} 
                  ,{name:"data_venda", label: "Data Venda"}
                  ,{name: "situacao", label: "Situação",
                    options: {
                      empty: true,
                      customBodyRenderLite: (dataIndex, rowIndex) =>  {
                        return (
                          <> 
                            <TextField 
                              select
                              size="small"
                              style= {{width: 170}}
                              value={dados[dataIndex].situacao}
                              onChange={(ev) => {
                                atualizaSituacao(dados[dataIndex].id_venda, ev.target.value)
                              }}
                            >
                              <MenuItem value ={1}>Emitido</MenuItem>
                              <MenuItem value ={2}>Em Separação</MenuItem> 
                              <MenuItem value ={3}>Em Trânsito</MenuItem>
                              <MenuItem value ={4}>Entregue</MenuItem>
                            </TextField>
                          </> 
                        );
                      }
                    }
                  } 
                  ,{name:"nome", label: "Cliente"}
                  ,{name:"qtde_venda", label: "Qtde Venda"}
                  ,{name:"valor_venda_formatado", label: "Valor Venda"}
                  ,{name:"usuario", label: "Responsável"}
                  ,{name: "",
                    options: {
                      filter: false,
                      sort: false,
                      empty: true,
                      customBodyRenderLite: (dataIndex, rowIndex) =>  {
                        return (
                          <> 
                            <ThemeProvider theme={Theme}>
                              <Button variant="contained" color="neutral" component={RouterLink} to={`${linkUsado}${dados[dataIndex].id_venda}`}>
                                {descricaoBotao}
                              </Button>
                            </ThemeProvider>
                          </> 
                        );
                      }
                    }
                  }
                  ]; 
    }                    
  }else if (localStorage.getItem(['tipo_comercio']) === '5') {
    // Agencia de Viagem
    if (localStorage.getItem(['menu_restrito']) === '1') {
      columns = [{name: "",
                  options: {
                    filter: false,
                    sort: false,
                    empty: true,
                    customBodyRenderLite: (dataIndex, rowIndex) =>  {
                      return (
                        <> 
                          <Avatar src={dados[dataIndex].url ? dados[dataIndex].url : imagemServico} alt="imagemProduto" sx={{ width: 100, height: 100 }} />
                        </> 
                      );
                  }
                  }
               }
              ,{name:"id_venda", label: "Código"} 
              ,{name:"data_venda", label: "Data Venda"}
              ,{name:"forma_pagamento", label: "Forma Pagto"} 
              ,{name:"nome", label: "Cliente"}
              ,{name:"companhia_aerea", label: "Companhia Aérea"}
              ,{name:"origem", label: "Origem"}
              ,{name:"destino", label: "Destino"}
              ,{name:"data_ida", label: "Data Ida"}
              ,{name:"codigo_reserva", label: "Cód. Reserva"}
              ,{name:"valor_venda_formatado", label: "Valor Venda"}
              ,{name:"usuario", label: "Responsável"}
              ];
    }else{
      columns = [{name: "Ação",
                options: {
                  filter: false,
                  sort: false,
                  empty: true,
                  customBodyRenderLite: (dataIndex, rowIndex) =>  {
                    return (
                      <> 
                        <MenuItem onClick={() => excluirVenda(dados[dataIndex].id_venda)} sx={{ color: 'text.secondary' }}>
                          <ListItemIcon>
                              <Iconify icon="eva:trash-2-outline" width={24} height={24} />
                          </ListItemIcon>
                        </MenuItem>

                        <MenuItem component={RouterLink} to={`/venda/editar/${dados[dataIndex].id_venda}`} sx={{ color: 'text.secondary' }}>
                          <ListItemIcon>
                              <Iconify icon="eva:edit-fill" width={24} height={24} />
                          </ListItemIcon>
                        </MenuItem>
                      </> 
                    );
                  }
                }
              }
              ,{name: "",
                options: {
                  filter: false,
                  sort: false,
                  empty: true,
                  customBodyRenderLite: (dataIndex, rowIndex) =>  {
                    return (
                      <> 
                        <Avatar src={dados[dataIndex].url ? dados[dataIndex].url : imagemServico} alt="imagemProduto" sx={{ width: 100, height: 100 }} />
                      </> 
                    );
                }
                }
              }
              ,{name:"id_venda", label: "Código"} 
              ,{name:"data_venda", label: "Data Venda"}
              ,{name:"forma_pagamento", label: "Forma Pagto"} 
              ,{name:"nome", label: "Cliente"}
              ,{name:"companhia_aerea", label: "Companhia Aérea"}
              ,{name:"origem", label: "Origem"}
              ,{name:"destino", label: "Destino"}
              ,{name:"data_ida", label: "Data Ida"}
              ,{name:"codigo_reserva", label: "Cód. Reserva"}
              ,{name:"valor_venda_formatado", label: "Valor Venda"}
              ,{name:"usuario", label: "Responsável"}
              ];
    } 
  }else if (localStorage.getItem(['tipo_comercio']) === '6') {    
    // Empresas com Templates/Produto
    if (localStorage.getItem(['menu_restrito']) === '1') {
      columns = [{name:"id_venda", label: "Código"} 
                ,{name:"forma_pagamento", label: "Forma Pagto"}
                ,{name:"numero_pedido_empresa", label: "Nº Pedido" }
                ,{name:"data_venda", label: "Data Venda"}
                ,{name: "situacao", label: "Situação",
                  options: {
                    empty: true,
                    customBodyRenderLite: (dataIndex, rowIndex) =>  {
                      return (
                        <> 
                          <TextField 
                            select
                            size="small"
                            style= {{width: 170}} 
                            value={dados[dataIndex].situacao}
                            onChange={(ev) => {
                              atualizaSituacao(dados[dataIndex].id_venda, ev.target.value)
                            }}
                          >
                            <MenuItem value ={1}>Emitido</MenuItem>
                            <MenuItem value ={2}>Em Separação</MenuItem> 
                            <MenuItem value ={3}>Em Trânsito</MenuItem>
                            <MenuItem value ={4}>Entregue</MenuItem>
                          </TextField>
                        </> 
                      );
                    }
                  }
                } 
                ,{name:"nome", label: "Cliente"}
                ,{name:"qtde_venda", label: "Qtde Venda"}
                ,{name:"valor_venda_formatado", label: "Valor Venda"}
                ,{name:"usuario", label: "Responsável"}
                ,{name: "",
                  options: {
                    filter: false,
                    sort: false,
                    empty: true,
                    customBodyRenderLite: (dataIndex, rowIndex) =>  {
                      return (
                        <> 
                          <ThemeProvider theme={Theme}>
                            <Button variant="contained" color="neutral" component={RouterLink} to={`${linkUsado}${dados[dataIndex].id_venda}`}>
                              {descricaoBotao}
                            </Button>
                          </ThemeProvider>
                        </> 
                      );
                    }
                  }
                }
                ];
    }else{
        columns = [{name: "Ação",
                    options: {
                      filter: false,
                      sort: false,
                      empty: true,
                      customBodyRenderLite: (dataIndex, rowIndex) =>  {
                        return (
                          <> 
                            <MenuItem onClick={() => excluirVenda(dados[dataIndex].id_venda)} sx={{ color: 'text.secondary' }}>
                              <ListItemIcon>
                                  <Iconify icon="eva:trash-2-outline" width={24} height={24} />
                              </ListItemIcon>
                            </MenuItem>
                          </> 
                        );
                      }
                    }
                  }  
                  ,{name:"id_venda", label: "Código"} 
                  ,{name:"forma_pagamento", label: "Forma Pagto"} 
                  ,{name:"numero_pedido_empresa", label: "Nº Pedido" }
                  ,{name:"data_venda", label: "Data Venda"}
                  ,{name: "situacao", label: "Situação",
                    options: {
                      empty: true,
                      customBodyRenderLite: (dataIndex, rowIndex) =>  {
                        return (
                          <> 
                            <TextField 
                              select
                              size="small"
                              style= {{width: 170}}
                              value={dados[dataIndex].situacao}
                              onChange={(ev) => {
                                atualizaSituacao(dados[dataIndex].id_venda, ev.target.value)
                              }}
                            >
                              <MenuItem value ={1}>Emitido</MenuItem>
                              <MenuItem value ={2}>Em Separação</MenuItem> 
                              <MenuItem value ={3}>Em Trânsito</MenuItem>
                              <MenuItem value ={4}>Entregue</MenuItem>
                            </TextField>
                          </> 
                        );
                      }
                    }
                  } 
                  ,{name:"nome", label: "Cliente"}
                  ,{name:"qtde_venda", label: "Qtde Venda"}
                  ,{name:"valor_venda_formatado", label: "Valor Venda"}
                  ,{name:"usuario", label: "Responsável"}
                  ,{name: "",
                    options: {
                      filter: false,
                      sort: false,
                      empty: true,
                      customBodyRenderLite: (dataIndex, rowIndex) =>  {
                        return (
                          <> 
                            <ThemeProvider theme={Theme}>
                              <Button variant="contained" color="neutral" component={RouterLink} to={`${linkUsado}${dados[dataIndex].id_venda}`}>
                                {descricaoBotao}
                              </Button>
                            </ThemeProvider>
                          </> 
                        );
                      }
                    }
                  }
                  ]; 
    }           
  }else{
    columns = [{name: "Ação",
              options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) =>  {
                  return (
                    <> 
                      <MenuItem onClick={() => excluirVenda(dados[dataIndex].id_venda)} sx={{ color: 'text.secondary' }}>
                        <ListItemIcon>
                            <Iconify icon="eva:trash-2-outline" width={24} height={24} />
                        </ListItemIcon>
                      </MenuItem>

                      <MenuItem component={RouterLink} to={`/venda/editar/${dados[dataIndex].id_venda}`} sx={{ color: 'text.secondary' }}>
                        <ListItemIcon>
                            <Iconify icon="eva:edit-fill" width={24} height={24} />
                        </ListItemIcon>
                      </MenuItem>
                    </> 
                  );
                }
              }
            }  
            ,{name:"id_venda", label: "Código"} 
            ,{name:"data_venda", label: "Data Venda"} 
            ,{name:"forma_pagamento", label: "Forma Pagto"}
            ,{name:"nome", label: "Cliente"}
            ,{name:"descricao", label: "Produto/Serviço"}
            ,{name:"qtde_venda", label: "Qtde Venda"}
            ,{name:"valor_venda_formatado", label: "Valor Venda"}
            ,{name:"total_pagamento_formatado", label: "Total Despesas"}
            ,{name:"lucro_liquido_formatado", label: "Lucro Liquido"} 
            ,{name:"usuario", label: "Responsável"}
            ,{name: "",
              options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) =>  {
                  return (
                    <> 
                      <ThemeProvider theme={Theme}>
                        <Button variant="contained" color="neutral" component={RouterLink} to={`${linkUsado}${dados[dataIndex].id_venda}`}>
                          {descricaoBotao}
                        </Button>
                      </ThemeProvider>
                    </> 
                  );
                }
              }
            }
            ];
  }                
  
  const useStyles = makeStyles((theme) => ({
    footerCell: {
        backgroundColor: "#cccccc",
        borderBottom: "none",
        color: "black",
        fontSize: 14,
        fontWeight: 'bold'
      }
  }));                  
  
  const classes  = useStyles();

  const options = {
    filterType: "dropdown",
    tableBodyHeight: "100%",
    selectableRows: "none",
    responsive: "standard",
    customTableBodyFooterRender: (opts) => {
        
      sumValorVenda = dados
        .reduce((total, item) => {
          return (total +  item.valor_venda);
      }, 0);

      sumValorDespesa = dados
        .reduce((total, item) => {
          return (total +  item.total_pagamento);
      }, 0);

      sumLucroLiquido = dados
        .reduce((total, item) => {
          return (total +  item.lucro_liquido);
      }, 0);

      return (
        <>
          {dados.length > 0 && (
            <TableFooter className={classes.footerCell}>
              <TableRow>
                {opts.selectableRows !== 'none' ? <TableCell className={classes.footerCell} /> : null}
                {opts.columns.map((col, index) => {
                  if (col.display === "true") {
                    if (col.name === "qtde_venda") {
                      return (
                        <TableCell key={index} className={classes.footerCell}>
                          TOTAL
                        </TableCell>
                      );
                    }if (col.name === "valor_venda_formatado") {
                      return (
                        <TableCell key={index} className={classes.footerCell}>
                          {fFormataDinheiro(sumValorVenda)}
                        </TableCell>
                      );
                    }if (col.name === "total_pagamento_formatado") {
                      return (
                        <TableCell key={index} className={classes.footerCell}>
                          {fFormataDinheiro(sumValorDespesa)}
                        </TableCell>
                      );
                    }if (col.name === "lucro_liquido_formatado") {
                      return (
                        <TableCell key={index} className={classes.footerCell}>
                          {fFormataDinheiro(sumLucroLiquido)}
                        </TableCell>
                      );
                    } 

                    if (col.name !== "qtde_venda" && col.name !== "valor_venda_formatado") {
                      return <TableCell key={index} className={classes.footerCell}/>
                    };
                  }
                  return <TableCell key={index} className={classes.footerCell}/>;
                  })
                }
              </TableRow>
            </TableFooter>
          )}
        </>
      );
  }
  };  

  let linkCadastro; 
  
  if (localStorage.getItem(['tipo_comercio']) === '2') {
      linkCadastro = "/venda_avulsa/consultar"; 
  }else if (localStorage.getItem(['tipo_comercio']) === '3') {
      linkCadastro = "/venda_avulsa_geral/consultar"; 
  }else{
      linkCadastro = "/venda/cadastrar";
  };   

  return (
    <Page title="Venda">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Consulta de Vendas
          </Typography>
          <ThemeProvider theme={Theme}>
            <Button variant="contained" color="neutral" component={RouterLink} to={linkCadastro} startIcon={<Iconify icon="eva:plus-fill" />}>
              Realizar Venda
            </Button>
          </ThemeProvider>
        </Stack>
        <Stack mb={5} direction={{ xs: 'column', sm: 'row' }} alignItems="center" justifyContent="space-between" spacing={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs} locale="pt-br" >
            <DatePicker
              label="Data Inicial"
              value={dataInicio}
              onChange={(newValue) => {
                setDataInicio(newValue);
              }}
              renderInput={(params) => <TextField {...params} fullWidth/>}
            />
            <DatePicker
              label="Data Fim"
              value={dataFim}
              onChange={(newValue) => {
                setDataFim(newValue);
              }}
              renderInput={(params) => <TextField {...params} fullWidth/>}
            />
          </LocalizationProvider>
          <TextField 
            select
            fullWidth
            label="Forma de Pagamento"
            value={formaPagamento}
            onChange={(ev) => {
              setFormaPagamento(ev.target.value)
            }}
          >
            <MenuItem value ="1">Dinheiro</MenuItem>
            <MenuItem value ="2">PIX</MenuItem> 
            <MenuItem value ="3">Cartão de Crédito</MenuItem>
            <MenuItem value ="4">Cartão de Débito</MenuItem>
          </TextField>
          {!exibeStatusViagem && null}
          {exibeStatusViagem &&
            <TextField 
            select
            fullWidth
            label="Status Viagem"
            value={statusViagem}
            onChange={(ev) => {
              setStatusViagem(ev.target.value)
            }}
          >
            <MenuItem value ="1">Pendente</MenuItem>
            <MenuItem value ="2">Realizada</MenuItem> 
          </TextField>}
          {!showElement && null}
          {showElement &&
            <Autocomplete
                getOptionLabel={(resultado) => resultado.descricao}
                options={usuarios}
                fullWidth
                onChange={(e, value) => { 
                  setUsuario(value?.usuario)
                }}
                renderInput={(params) => (<TextField {...params} 
                                            label="Funcionário" 
                                            fullWidth
                                            />
                                          )}
                isOptionEqualToValue={(option, value) => option.usuario === value.usuario}
            />}
          <ThemeProvider theme={Theme}>
            <Button fullWidth size="large" type="submit" variant="contained" color="neutral" onClick={getVendas}>
              Consultar
            </Button>
          </ThemeProvider>
        </Stack>
        {!removeLoading && <Loading/>}
        {removeLoading && <Card>
            <Stack spacing={3}>
              {status.type === 'erro' ? <Alert severity="error"><AlertTitle>Erro</AlertTitle>{status.mensagem}</Alert> : ""}
              {status.type === 'success' ? <Alert severity="success"><AlertTitle>Sucesso</AlertTitle>{status.mensagem}</Alert> : ""}
            </Stack > 
            <MUIDataTable
                data={Object.values(dados)}
                columns={columns}  
                options={options} 
            />
        </Card>}
      </Container>  
    </Page>  
  );
}

